import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";
const getToken = () => {
  return localStorage.getItem("token");
};
export const AllGeofenceSummaryReport = async (StartDate, endDatae) => {
  try {
    const response = await axiosInstance.get(
      API_BASE_URL1 +
        `GeoFence/GetGeoFenceSummaryData?startDate=${StartDate}&endDate=${endDatae}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`
          }
        }
      );
      return response;
    } catch (error) {
      throw error;
    }
};

export const AllGeofenceVehicleReport = async (StartDate, endDatae) => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL1 +
          `GeoFence/GetGeoFenceVehicleData?startDate=${StartDate}&endDate=${endDatae}`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const AllGeofenceVehicleSummaryReport = async (StartDate, endDatae) => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL1 +
          `GeoFence/GetGeoFenceSummaryVehicleData?StartDate=${StartDate}&EndDate=${endDatae}`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          }
      );
      return response;
    } catch (error) {
      throw error;
    }
  };